import { FC, useEffect } from 'react';
import { Typography, Paper } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import orderState, { serviceOfferState, currentOrderMessagesState } from 'TaxAnalyticsState/orderState';
import { useRecoilState } from 'recoil';
import { DeloitteCard } from 'TaxAnalyticsUI/Deloitte';
import { ServiceOfferLevelDTO } from 'TaxAnalyticsHelpers/TaxAnalyticsClient';

export const OrderSelect: FC = (props: any) => {
    const [order, setOrderState] = useRecoilState(orderState);
    const [serviceOffer, setServiceOffer] = useRecoilState(serviceOfferState);
    const [, setOrderMessages] = useRecoilState(currentOrderMessagesState);

    const selectLevel = (level: ServiceOfferLevelDTO | undefined) => {
        setServiceOffer({ ...serviceOffer, selectedLevel: level });
        const selectedServiceOfferLevel = order?.serviceOffer?.serviceOfferLevels?.find(o => o.name === level?.name);
        if (selectedServiceOfferLevel)
            setOrderMessages([]);
        setOrderState({ ...order, serviceOfferLevelId: selectedServiceOfferLevel?.id, serviceOfferLevel: selectedServiceOfferLevel });
    }

    useEffect(() => {
        if (!order?.serviceOfferLevel && order?.serviceOffer?.serviceOfferLevels?.length === 1)
            selectLevel(order.serviceOffer.serviceOfferLevels[0]);
        else {
            if (serviceOffer.selectedLevel && order!.serviceOffer!.serviceOfferLevels!.findIndex(sl => sl.code === serviceOffer?.selectedLevel?.code) > -1)
                selectLevel(serviceOffer?.selectedLevel);
            else {
                if (order && !order.serviceOfferLevelId)
                    setOrderMessages([{ message: "Sélectionner un niveau de service", type: "error" }]);
                else
                    setOrderMessages([]);
            }
        }
    }, []);

    return (
        <Paper elevation={0}>
            <Grid container spacing={4}>
                <Grid container alignItems="center" justifyContent="center">
                    <Grid>
                        <Typography style={{ textAlign: 'center' }} variant="h4">{order?.serviceOfferLevel ? `Niveau de prestation choisi : ${order?.serviceOfferLevel.name}` : 'Sélectionner le niveau de service'}</Typography>
                    </Grid>
                </Grid>
                <Grid container alignItems="stretch" spacing={4}>
                    {order && order.serviceOffer?.serviceOfferLevels &&
                        order.serviceOffer?.serviceOfferLevels.map((level, index) => {
                            const offerLevelInfo = serviceOffer?.offer?.offerLevels?.find(l => l.code === level.code);
                            if (offerLevelInfo)
                                return (
                                    <Grid xs={12} md={4} key={index} order={offerLevelInfo.displayOrder}>
                                        <DeloitteCard text={offerLevelInfo.text} title={offerLevelInfo.title} buttonLabel="Sélectionner" cta onClick={() => { selectLevel(order?.serviceOfferLevelId === level.id ? undefined : level); }} selected={order?.serviceOfferLevel?.code === offerLevelInfo.code}></DeloitteCard>
                                    </Grid>
                                )
                        })
                    }
                </Grid>
            </Grid>
        </Paper>
    );
}